// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tabs-tabs-a863b{background:#fff;font-size:.42rem;padding:.3rem 0}.tabs-tabs-a863b .tabs-inner-dc1ac{background:#f5f5f5;border-radius:.27rem;display:flex;margin:0 .3rem}.tabs-tabs-a863b .tabs-tab-25b19{color:#1f1f1f;flex:1;margin:.06rem;padding:.13rem .24rem;text-align:center}.tabs-tabs-a863b .tabs-tab-25b19.tabs-activated-4b799{background:#fff;border-radius:.22rem;box-shadow:0 0 .04rem 0 rgba(0,0,0,.1);color:#00c8c8;font-weight:700}.tabs-tabs-a863b.tabs-fixed-7f99b{position:fixed;top:0;width:100%;z-index:999}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tabs": "tabs-tabs-a863b",
	"inner": "tabs-inner-dc1ac",
	"tab": "tabs-tab-25b19",
	"activated": "tabs-activated-4b799",
	"fixed": "tabs-fixed-7f99b"
};
export default ___CSS_LOADER_EXPORT___;
